import { createRequestTypes } from '../../../../redux/actions/utils';

export const GET_USERS = createRequestTypes('GET_USERS');
export const getUsers = (params) => ({ type: GET_USERS.REQUEST, params});

export const ADD_USER = createRequestTypes('ADD_USER');
export const addUser = (params) => ({type: ADD_USER.REQUEST, params});

export const EDIT_USER = createRequestTypes('EDIT_USER');
export const editUser = (params) => ({type: EDIT_USER.REQUEST, params});

export const DELETE_USER = createRequestTypes('DELETE_USER');
export const deleteUser = (params) => ({type: DELETE_USER.REQUEST, params});

export const CLEAR_DATA = 'CLEAR_DATA';
export const clearData = () => ({ type: CLEAR_DATA});

export const EXPORT_USER = createRequestTypes('EXPORT_USER');
export const exportUser = (params) => ({ type: EXPORT_USER.REQUEST, params}); 

export const LOGOUT = 'LOGOUT';
export const logout = () => ({ type: LOGOUT});